import Endpoints from 'constants/Endpoints'
import { RestRequestPOST, SoftLogout } from 'libs/RestRequest';
import Axios from 'axios';

const logout = async () => {
	try {
		const resp = await RestRequestPOST(Endpoints.oauth.LOGOUT);
		await SoftLogout(resp.result);
	} catch (error) {
		console.error({error})
	}
}

const getToken = async (code) => {
	try {
		const res = await Axios({
			method: 'post',
			url: Endpoints.oauth.TOKEN,
			params: {
				grant_type: 'authorization_code',
				code,
				redirect_uri: Endpoints.redirect_uri,
				client_id: 'mp'
			},
		});
		localStorage.setItem("authorize", JSON.stringify(res.data));
		return true;
	} catch (error) {
		return false;
	}
}

export default {
	logout,
	getToken,
};